<script setup lang="ts">
const route = useRoute('cupom-cupom');

const { checkCupomCode, setTempCoupon } = useCouponStore();
const { isAuthenticated } = storeToRefs(useAuthStore());
const { openModal } = useLayoutStore();

const coupon_param = computed(() => {
  return route.params.cupom || '';
});

const show_which_modal = computed(() => {
  // @ts-ignore
  if (route.params.login) {
    return 'login';
  } else {
    return 'register';
  }
});

onMounted(() => {
  if (isAuthenticated.value) {
    checkCupomCode(coupon_param.value);
  } else {
    openModal(show_which_modal.value);
    setTempCoupon(coupon_param.value);
  }
});

const { isHomeAsSportbookEnabled } = useFeatureFlagsNew();
</script>

<template>
  <template v-if="isHomeAsSportbookEnabled">
    <PagesSports />
  </template>

  <PagesHome v-else />
</template>
